import React, { useState } from "react";
import FormContacto from "../../Components/FormularioContacto/FormContacto";
import "../Contacto/Contacto.scss";
import "./Tamanosterrenos.scss";
import {
  Backgroundbigcontainer,
  Containeramenidades,
  Littleline,
  Montserrat,
} from "../../Components/Styled";
import { Grid } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { Roboto } from "../../Components/Styled2";
import { Informacion_Disponibilidad } from '../../utils'

const Tamanosterrenos = ({ disponibilidad }) => {

  const { Imagenes } = Informacion_Disponibilidad;

  const [showPopup, setShowPopup] = useState(false);

  function togglePopup() {
    setShowPopup(!showPopup);
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section ref={disponibilidad} className="Section-Infraestructura">
      <Backgroundbigcontainer
        className="Tamanos-Terrenos"
        varpadding="77px 0 118px"
        varpaddingm="50px 0 70px"
        varbackgroundcolor="#F5F5F5"
      >
        <Containeramenidades>
          <Littleline />
          <Montserrat
            varweight="600"
            fontsize="48px"
            fontsizem="22px"
            varmargin="20px auto"
          >
            Disponibilidad
          </Montserrat>

          <Grid
            className="tamanos-container"
            container
            spacing={2}
            style={{ gridColumnGap: "0px" }}
          >
            <Grid className="tamanos-item " item md={12} sm={12} xs={12}>
            <div className="tablas-wrapper">
            <div className="tablas">
                <table className="mi-tabla">
                  <tbody>
                    <tr>
                      <td colspan="2" className="celdas_negras" style={{ width: '100%', textAlign: 'center', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                        <span>FASE 1 | VENTA</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan='2' style={{ width: '100%', textAlign: 'center', height: '10px'}} className="celdas_B_fases">
                        <span>Precio m²: <span style={{ fontWeight: '650' }}>$4,150.00</span></span>
                        <span className="texto_pequeno">FINANCIAMIENTO(A 36 MESES SIN INTERESES)</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan='2' style={{ width: '100%', textAlign: 'center', height: '10px'}} className="celdas_B_fases">
                        <span>Precio m²: <span style={{ fontWeight: '650' }}>$4,000.00</span> <br />
                          <span className="texto_pequeno">(CONTADO)</span>
                        </span>
                      </td>
                    </tr>
                    <tr className="celdas_rojas">
                      <td>
                        <span>LOTES</span>
                      </td>
                      <td>
                        <span>160 m²</span>
                      </td>
                    </tr>
                    <tr className="celdas_grises">
                      <td style={{ fontWeight: "bold" }}>
                        <span>APARTADO</span>
                      </td>
                      <td>
                        <span>$7,000.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>VALOR TOTAL</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b', borderRight: '1px solid #cb100b'}}>
                        <span>$664,000.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>ANTICIPO 1 (15%)</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b', borderRight: '1px solid #cb100b'}}>
                        <span>$99,600.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>ANTICIPO 2 (15%)</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b', borderRight: '1px solid #cb100b'}}>
                        <span>$99,600.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <div>
                          <span>RESTANTE</span>
                        </div>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b', borderRight: '1px solid #cb100b'}}>
                        <span>$464,800.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>MENSUALIDAD (36 MSI)</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderRight: '1px solid #cb100b'}}>
                        <span>$12,911.11</span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="mi-tabla_2">
                  <tbody>
                    <tr>
                      <td colspan="3" className="celdas_negras" style={{ width: '100%', textAlign: 'center', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                        <span>FASE 2 | EN PREVENTA</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan='3' style={{ width: '100%', textAlign: 'center', height: '10px' }} className="celdas_B_fases">
                        <span>Precio m²: <strong>$3,950</strong></span>
                        <span className="texto_pequeno">FINANCIAMIENTO(A 36 MESES SIN INTERESES)</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan='3' style={{ width: '100%', textAlign: 'center', height: '10px'}} className="celdas_B_fases">
                        <span>Precio m²: <strong>$3,800</strong><br/>
                          <span className="texto_pequeno">(CONTADO)</span>
                        </span>
                      </td>
                    </tr>
                    <tr className="celdas_rojas">
                      <td>
                        <span>LOTES</span>
                      </td>
                      <td>
                        <span>200 m²</span>
                      </td>
                      <td>
                        <span>250 m²</span>
                      </td>
                    </tr>
                    <tr className="celdas_grises">
                      <td style={{ fontWeight: "bold" }}>
                        <span>APARTADO</span>
                      </td>
                      <td>
                        <span>$10,000.00</span>
                      </td>
                      <td>
                        <span>$15,000.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>VALOR TOTAL</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b'}}>
                        <span>$790,000.00</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b'}}>
                        <span>$987,500.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>ANTICIPO 1 (15%)</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b'}}>
                        <span>$118,500.00</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b', borderTop: '2px solid #cb100b'}}>
                        <span>$148,125.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>ANTICIPO 2 (15%)</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b'}}>
                        <span>$118,500.00</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b', borderTop: '2px solid #cb100b'}}>
                        <span>$148,125.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <div>
                          <span>RESTANTE</span>
                        </div>
                      </td>

                      <td style={{borderBottom: '2px solid #cb100b'}}>
                        <span>$553,000.00</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b', borderTop: '2px solid #cb100b'}}>
                        <span>$691,250.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>MENSUALIDAD (36 MSI)</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b'}}>
                        <span>$15,361.11</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b', borderTop: '2px solid #cb100b'}}>
                        <span>$19,201.39</span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="mi-tabla_2">
                  <tbody>
                    <tr>
                      <td colspan="3" className="celdas_negras" style={{ width: '100%', textAlign: 'center', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                        <span>FASE 3 | EN PREVENTA</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan='3' style={{ width: '100%', textAlign: 'center', height: '10px' }} className="celdas_B_fases">
                        <span>Precio m²: <strong>$3,700</strong></span>
                        <span className="texto_pequeno">FINANCIAMIENTO(A 36 MESES SIN INTERESES)</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan='3' style={{ width: '100%', textAlign: 'center', height: '10px'}} className="celdas_B_fases">
                        <span>Precio m²: <strong>$3,550</strong><br/>
                          <span className="texto_pequeno">(CONTADO)</span>
                        </span>
                      </td>
                    </tr>
                    <tr className="celdas_rojas">
                      <td>
                        <span>LOTES</span>
                      </td>
                      <td>
                        <span>160 m²</span>
                      </td>
                      <td>
                        <span>200 m²</span>
                      </td>
                    </tr>
                    <tr className="celdas_grises">
                      <td style={{ fontWeight: "bold" }}>
                        <span>APARTADO</span>
                      </td>
                      <td>
                        <span>$7,000.00</span>
                      </td>
                      <td>
                        <span>$10,000.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>VALOR TOTAL</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b'}}>
                        <span>$592,000.00</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b'}}>
                        <span>$740,000.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>ANTICIPO 1 (15%)</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b'}}>
                        <span>$88,800.00</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b', borderTop: '2px solid #cb100b'}}>
                        <span>$111,000.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>ANTICIPO 2 (15%)</span>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b'}}>
                        <span>$88,800.00</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b', borderTop: '2px solid #cb100b'}}>
                        <span>$111,000.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <div>
                          <span>RESTANTE</span>
                        </div>
                      </td>
                      <td style={{borderBottom: '2px solid #cb100b'}}>
                        <span>$414,400.00</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b', borderTop: '2px solid #cb100b'}}>
                        <span>$518,000.00</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="celdas_rojas">
                        <span>MENSUALIDAD (36 MSI)</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b'}}>
                        <span>$11,511.11</span>
                      </td>
                      <td style={{borderBottom: '1px solid #cb100b', borderLeft: '2px solid #cb100b', borderRight: '1px solid #cb100b', borderTop: '2px solid #cb100b'}}>
                        <span>$14,388.89</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
              <div className="promo-anticipo">
                  <p className="promo-anticipo__highlight">PROMOCIÓN: Paga anticipo del 30% en 2 partes.**</p>
                  <p>-15% de anticipo a la firma y segundo 15% antes del 15 Diciembre 2026.**</p>
              </div>
              <button type="button" className="button-contacto tablas-contacto-btn" onClick={togglePopup}>
                Contactar un asesor express
              </button>
            </Grid>
            <Grid className="tamanos-item tres" item md={12} sm={12} xs={12}>
              <div className="disponibilidad-carrusel">
                <Slider className="disponibilidad-slider" {...settings}>
                  {Imagenes.map((imgs) => (
                    <div key={imgs.id} className={`backgrounds-containers imagen-${imgs.id}`}>
                      <img src={imgs.img} alt={imgs.alt} />
                    </div>
                  ))}
                </Slider>
              </div>
            </Grid>
          </Grid>
         
          {showPopup && <FormContacto closePopup={togglePopup} />}
        </Containeramenidades>
      </Backgroundbigcontainer>
    </section>
  );
};

export default Tamanosterrenos;
